import { render } from "./VehicleDetailPage.vue?vue&type=template&id=9619bbb4&scoped=true"
import script from "./VehicleDetailPage.vue?vue&type=script&lang=js"
export * from "./VehicleDetailPage.vue?vue&type=script&lang=js"

import "./VehicleDetailPage.vue?vue&type=style&index=0&id=9619bbb4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9619bbb4"]])

export default __exports__